<template>
  <div>
    <mf-card-container class="py-8 px-6">
      <template v-slot:title-complement>
        <span class="title d-flex align-center">
          Configuração Push Aplicativo
          <v-icon class="ml-1 channel-icon">mdi-cellphone</v-icon>
        </span>
      </template>

      <redirection ref="redirection" class="mt-3" :settings-id="settingsId" />
    </mf-card-container>

    <mf-card-container class="mt-5" title="Mensagem">
      <template v-slot:headers>
        <div class="d-flex" style="gap: 16px">
          <best-offer-configuration-dialog channel="push" :offer-type="selectedOfferType" @updated-variables="countAllCharacters" />
          <template-message-modal v-model="selectedTemplate" :mode="['PUSH']" />
        </div>
      </template>

      <push-configuration ref="push-configuration" class="px-6 mt-n4" :settings-id="settingsId" @update:selected-offer-type="selectedOfferType = $event" />
    </mf-card-container>
  </div>
</template>

<script>
import Redirection from './Redirection.vue'
import PushConfiguration from './PushConfiguration.vue'

// Lazy-loaded components
const TemplateMessageModal = () => import('@/components/template-message/TemplateMessageModal.vue')
const BestOfferConfigurationDialog = () =>
  import('@/modules/maria/campanha-da-maria-v2/views/components/ChannelsConfiguration/BestOfferConfiguration/BestOfferConfigurationDialog.vue')

export default {
  name: 'PushForm',

  components: {
    Redirection,
    PushConfiguration,
    TemplateMessageModal,
    BestOfferConfigurationDialog,
  },

  props: {
    settingsId: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    selectedTemplate: {},
    selectedOfferType: 'offer_sales',
  }),

  computed: {
    pushConfigurationRef() {
      return this.$refs?.['push-configuration']
    },

    redirectionRef() {
      return this.$refs?.['redirection']
    },
  },

  watch: {
    selectedTemplate(template) {
      if (this.pushConfigurationRef) {
        this.pushConfigurationRef.selectTemplate(template)
      }
    },
  },

  methods: {
    countAllCharacters() {
      this.pushConfigurationRef.countAllCharacters()
    },

    /**
     * Validates both push configuration and redirection inputs
     * @returns {boolean} Whether all inputs are valid
     */
    validInput() {
      const pushValid = this.pushConfigurationRef?.validInput()
      const redirectionValid = this.redirectionRef?.validInput()

      return pushValid && redirectionValid
    },

    /**
     * Gets the combined channel data from push configuration and redirection
     * @returns {Object} The complete channel configuration data
     */
    getChannelData() {
      if (!this.pushConfigurationRef || !this.redirectionRef) {
        return {}
      }

      const pushData = this.pushConfigurationRef.getChannelData()
      const redirectionAction = this.redirectionRef.getAction

      return {
        ...pushData,
        message: {
          ...pushData.message,
          action: {
            ...redirectionAction,
          },
        },
      }
    },
  },
}
</script>
